<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg">
          <v-toolbar color="#f8f9fb" elevation="0">
            <v-toolbar-title>{{
              `${this.$t("bills.add.title")}`
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="$router.go(-1)">
              <v-icon left> mdi-chevron-double-left </v-icon>
              {{ `${this.$t("bills.add.buttons.back")}` }}
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text class="pa-10">
            <v-form>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    v-model="bill.type"
                    label="Type"
                    :items="types"
                    item-text="text"
                    item-value="value"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-radio-group row v-model="sendto">
                    <v-radio label="All" value="1" />
                    <v-radio label="Flat" value="2" />
                    <v-radio label="Single House" value="3" />
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="sendto == '2'">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    v-model="bill.flat_id"
                    label="Flat"
                    :items="flats"
                    item-text="name"
                    item-value="id"
                  />
                </v-col>
              </v-row>
              <v-row v-if="['2', '3'].includes(sendto)">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    v-model="bill.members"
                    label="Houses"
                    :items="houses"
                    item-text="house_number"
                    item-value="id"
                    multiple
                  >
                    <template v-slot:prepend-item>
                      <v-list-item ripple @click="toggle">
                        <v-list-item-action>
                          <v-icon
                            :color="bill.members.length > 0 ? 'primary' : ''"
                          >
                            {{ icon }} {{ bill.members.length }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            Select All
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="bill.title"
                    name="title"
                    label="Title"
                    v-validate="'required'"
                    :error="
                      errors.first('title') != null ||
                        serverSideErrors.title != null
                    "
                    :error-messages="
                      errors.first('title') || serverSideErrors.title
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-textarea
                    v-model="bill.description"
                    name="description"
                    label="Description"
                    v-validate="'required'"
                    rows="2"
                    :error="
                      errors.first('description') != null ||
                        serverSideErrors.description != null
                    "
                    :error-messages="
                      errors.first('description') ||
                        serverSideErrors.description
                    "
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="bill.amount"
                    name="amount"
                    label="Amount"
                    type="number"
                    @keyup="setRentalVal()"
                    v-validate="'required|numeric|max_value:9999999|min_value:1'"
                    :error="
                      errors.first('amount') != null ||
                        serverSideErrors.amount != null
                    "
                    :error-messages="
                      errors.first('amount') || serverSideErrors.amount
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="bill.amount_for_rental"
                    name="amount for rental"
                    label="Amount For Rental"
                    type="number"
                    v-validate="'required|numeric|max_value:9999999|min_value:1'"
                    :error="
                      errors.first('amount for rental') != null ||
                        serverSideErrors.amount_for_rental != null
                    "
                    :error-messages="
                      errors.first('amount for rental') ||
                        serverSideErrors.amount_for_rental
                    "
                  />
                </v-col>
              </v-row>
              <v-row v-if="bill.type == 1">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="bill.one_time_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="bill.one_time_date"
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="bill.one_time_date"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu.save(bill.one_time_date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row v-if="bill.type == 2 || bill.type == 3">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    label="Day of month"
                    v-model="bill.day_of_month"
                    :items="dates"
                  />
                </v-col>
              </v-row>
              <v-row v-if="bill.type == 3">
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-select
                    label="Month"
                    v-model="bill.month"
                    item-text="name"
                    item-value="id"
                    :items="months"
                  />
                </v-col>
              </v-row>
               <v-row >
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-text-field
                    v-model="bill.due_days"
                    name="due days"
                    label="Due Days"                    
                    type="number"
                    v-validate="'required|numeric|max_value:364'"
                    :error="
                      errors.first('due days') != null ||
                        serverSideErrors.due_days != null
                    "
                    :error-messages="
                      errors.first('due days') ||
                        serverSideErrors.due_days
                    "
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="6">
                  <v-file-input
                    v-model="bill.documents"
                    label="Bill Documents"
                    prepend-icon="mdi-camera"
                    multiple
                    :error="serverSideErrors.documents != null"
                    :error-messages="serverSideErrors.documents"
                    hint="Only jpg, png, gif, pdf, jpeg, svg file types are allowed"
                    persistent-hint
                    ><template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template></v-file-input
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-btn
              color="secondary"
              dark
              class="px-8 ml-2"
              @click="saveBill"
              :loading="loading"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      user: {},
      loading: false,
      member: {},
      serverSideErrors: {},
      bill: {
        type: 1,
        flat_id: null,
        title: "",
        description: "",
        documents: [],
        members: [],
        amount: 0,
        amount_for_rental: 0,
        one_time_date: new Date().toISOString().slice(0, 10),
        day_of_month: null,
        month: null,
        due_days: null,
      },
      sendto: '1',
      types: [
        {
          text: "One Time",
          value: 1,
        },
        {
          text: "Monthly",
          value: 2,
        },
        {
          text: "Yearly",
          value: 3,
        },
      ],
      flats: [],
      houses: [],
      menu: false,
      modal: false,
      nowDate: new Date().toISOString().slice(0, 10),
      dates: Array.from({ length: 28 }, (_, i) => i + 1),
      months: [
        {
          id: 1,
          name: "January"
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December"
        },
      ],
    };
  },
  watch: {
    sendto: function() {
      if(this.sendto == '1') {
        this.bill.flat_id = null;
        this.bill.members = [];
      } else if(this.sendto == '2') {
        this.bill.members = [];
        this.getFlats();
      } else {
        this.bill.flat_id = null;
        this.bill.members = [];
        this.getHouses();
      }
    },
    "bill.flat_id": function() {
      this.bill.members = [];
      this.getHouses();
    }
  },  
  computed: {
    sendtoAllHouses() {
      return this.bill.members.length === this.houses.length;
    },
    sendtoSelectedHouses() {
      return this.bill.members.length > 0 && !this.sendtoAllHouses;
    },
    icon() {
      if (this.sendtoAllHouses) return "mdi-close-box";
      if (this.sendtoSelectedHouses) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    setRentalVal(){
      this.bill.amount_for_rental = this.bill.amount;
    }, 
    saveBill() {
      let _self = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;
          let formData = new FormData();

          let one_time_date = '';

          if(this.bill.one_time_date) {
            one_time_date = moment(this.bill.one_time_date).utc().valueOf();
          }

          formData.append("type", this.bill.type ? this.bill.type : '');
          formData.append("flat_id", this.bill.flat_id ? this.bill.flat_id : '');
          formData.append("title", this.bill.title);
          formData.append("description", this.bill.description);
          
          for(let m = 0; m<this.bill.members.length; m++) {
            formData.append("members[]",this.bill.members[m])
          }
          formData.append("send_to", this.sendto);
          formData.append("amount", this.bill.amount);
          formData.append("amount_for_rental", this.bill.amount_for_rental ? this.bill.amount_for_rental : '');
          formData.append("one_time_date", one_time_date);
          formData.append("day_of_month", this.bill.day_of_month ? this.bill.day_of_month : '');
          formData.append("month", this.bill.month ? this.bill.month : '');
          formData.append("due_days", this.bill.due_days);

          if (this.bill.documents) {
            for (let i = 0; i < this.bill.documents.length; i++) {
              formData.append("documents[]", this.bill.documents[i]);
            }
          }

          _self.$axios
            .post("/societyadmin/bills/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              let data = response.data;

              _self.loading = false;
              _self.serverSideErrors = {};

              if (data.status) {
                this.setAlert({
                  showAlert: true,
                  message: data.message,
                  variant: "green accent-4",
                  timeout: 2000,
                });
                _self.$router.push({ path: "/societyadmin/bills" });
              } else {
                if (!data.errors) {
                  this.setAlert({
                    showAlert: true,
                    message: data.message,
                    variant: "red accent-3",
                    timeout: 2000,
                  });
                } else {
                  for (let i = 0; i < data.errors.length; i++) {
                    this.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                }
              }
            });
        }
      });
    },
    toggle() {
      this.$nextTick(() => {
        if (this.sendtoAllHouses) {
          this.bill.members = [];
        } else {
          this.bill.members = this.houses.map((h) => h.id);
        }
      });
    },
    getFlats() {
      this.$axios.get(`/societyadmin/flats`)
        .then((response) => {
          let data = response.data;
          if(data.status) {
            this.flats = data.flats;
          } else {
            this.setAlert({
              showAlert: true,
              message: data.message,
              variant: "red accent-3",
              timeout: 2000,
            });
          }
        });
    },
    getHouses() {
      this.$axios.get(`/societyadmin/houses`,{
        params: {
          flat_id: this.bill.flat_id
        }
      })
        .then((response) => {
          let data = response.data;
          if(data.status) {
            this.houses = data.houses;
          } else {
            this.setAlert({
              showAlert: true,
              message: data.message,
              variant: "red accent-3",
              timeout: 2000,
            });
          }
        });
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getFlats();
  },
};
</script>

<style scoped>
.font-30 {
  font-size: 30px !important;
}
/* make the icon clickable in badge slot */
.edit-icon {
  z-index: 1000;
}
</style>
